import React, { useEffect } from 'react';

interface IProps { }

const PosnetApp: React.FC<IProps> = () => {

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const posnetAppToken = searchParams.get("posnetAppToken");
        if (!posnetAppToken) {
            window.location.href = "/posnet-blank";
            return;
        }
        const redirect = searchParams.get("redirect");
        const safeRedirect = (redirect && redirect.startsWith("/")) ? redirect : "/posnet-blank";
        localStorage.setItem("user", JSON.stringify({ token: posnetAppToken, roles: ["PosnetAppUser"] }));
        window.location.href = safeRedirect;
    }, []);

    return null;

}

export default PosnetApp;